"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServerState = void 0;
const react_1 = require("react");
/**
 * Same as `useServerState` but simply returns the object without future updates that hooks normally provide.
 * @see useServerState
 */
const getServerState = function () {
  var _window;
  let propName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  const data = process.env.BUILD_TARGET !== 'server' && typeof window !== 'undefined' ? // eslint-disable-next-line no-underscore-dangle
  (_window = window) === null || _window === void 0 ? void 0 : _window.__SERVER_APP_STATE__ : {} || {};
  return propName ? data === null || data === void 0 ? void 0 : data[propName] : data;
};
exports.getServerState = getServerState;
/**
 * Pulls the Server App State from the client DOM and returns either the entire object, or state[propname], if provided.
 *
 * ONLY USABLE ON CLIENT. SERVER WILL RETURN UNDEFINED OR EMPTY OBJECT.
 * @param {String} propName
 */
const useServerState = propName => {
  const [foundData, setFoundData] = (0, react_1.useState)((0, exports.getServerState)(propName));
  (0, react_1.useEffect)(() => {
    setFoundData((0, exports.getServerState)(propName));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return foundData;
};
exports.default = useServerState;